import { useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { usePatient } from '@hooks/usePatients'
import { useActivePatient } from '@context/ActivePatientContext'
import { Link } from 'react-router-dom'
import { Button } from '@components/ui/button'

export function PatientDetailPage() {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const { setActivePatient } = useActivePatient()
  const { data: patient, isLoading } = usePatient(id || '')

  useEffect(() => {
    if (patient) {
      setActivePatient(patient)
      navigate(`/workspace/patient/${patient.id}/datos-paciente`, { replace: true })
    }
  }, [patient])

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-ml-primary" />
      </div>
    )
  }

  if (!patient) {
    return (
      <div className="text-center py-12">
        <h2 className="text-xl font-headline text-ml-primary">Paciente no encontrado</h2>
        <Button asChild className="mt-4 bg-ml-primary text-white hover:bg-ml-primary-container rounded">
          <Link to="/patients">Volver a Pacientes</Link>
        </Button>
      </div>
    )
  }

  return (
    <div className="flex items-center justify-center h-64">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-ml-primary" />
    </div>
  )
}
